import { render, staticRenderFns } from "./FridayWarranty.vue?vue&type=template&id=744fc36c&"
import script from "./FridayWarranty.vue?vue&type=script&lang=js&"
export * from "./FridayWarranty.vue?vue&type=script&lang=js&"
import style0 from "./FridayWarranty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports